import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header_ouvid';
import Head from '../../components/head';
import Footer from '../../components/footer';
import RespondeOuvir from '../../components/ouvidoria/listar/form_status';


function OuvidRespondeScreen () {
    return (
        <Fragment>
            <Head titulo="Respondendo requisição"/>
            <Header />
            <Container>
                <RespondeOuvir />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default OuvidRespondeScreen;